import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    .breadcrumbs-component {
        padding-top: 10em;
    }

    @media all and (max-width: ${variables.tabletL}) {
        .breadcrumbs-component {
            padding-top: 8em;
        }
    }
`;
